import { Smartphone } from "lucide-react";
import { STEPS } from "../../config/site";
import { SectionHeading } from "../common/SectionHeading";

export const StepsSection = ({ label = "How it works", title = "Three steps to a reachable vehicle." }) => (
  <section data-testid="how-it-works-section" className="section-pad">
    <div className="container-x">
      <SectionHeading label={label} title={title} />
      <ol className="mt-14 grid gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10 md:grid-cols-3">
        {STEPS.map((s) => (
          <li key={s.n} data-testid={`step-${s.n}`} className="group bg-[#0F111A] p-8 transition-colors duration-300 hover:bg-[#151824] lg:p-10">
            <span className="font-mono text-5xl font-bold text-white/10 transition-colors duration-300 group-hover:text-[#FF5500]">{s.n}</span>
            <h3 className="mt-8 font-display text-xl font-semibold uppercase tracking-wide text-slate-50">{s.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-slate-400 sm:text-base">{s.body}</p>
          </li>
        ))}
      </ol>
      <p data-testid="no-app-note" className="mt-8 inline-flex items-center gap-3 rounded-lg border border-[#00E676]/25 bg-[#00E676]/5 px-4 py-3 text-sm text-slate-200">
        <Smartphone className="h-4 w-4 text-[#00E676]" aria-hidden="true" />
        The person scanning the QR code does not need an app.
      </p>
    </div>
  </section>
);
